import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import Meta from '../../../../model/Meta';

/* Steps */
import DefaultView from './DefaultView';
import SecretaryCertificateToSellStep1 from './SecretaryCertificateToSellStep1';
import SecretaryCertificateToSellStep2 from './SecretaryCertificateToSellStep2';
import SecretaryCertificateToSellStep3 from './SecretaryCertificateToSellStep3';
import Ty from './Ty';

class SecretaryCertificateToSell extends Component {

	render() {
		const meta = {
			title: "Secretary Certificate to Sell Contract",
			description: "A Secretary’s Certificate (to Sell) is a document executed by the Corporate Secretary stating that the Board of Directors has voted to sell a real property owned and registered under the name of the corporation and has likewise delegated a corporate representative who shall execute the necessary sale documents. This document is important because it serves as a proof that the corporate representative has the authority to enter into a sale agreement with third parties for and in behalf of the corporation."
		}
		return (
			<div className="page page-inner page-contract">
				<Meta {...meta}/>
				<div className="container-fluid">
					<div className="p-0">
						<div className="page-content py-3">

							<Switch>
								<Route path="/contracts/free-contracts/secretary-certificate-to-sell/1" component={SecretaryCertificateToSellStep1} />
								<Route path="/contracts/free-contracts/secretary-certificate-to-sell/2" component={SecretaryCertificateToSellStep2} />
								<Route path="/contracts/free-contracts/secretary-certificate-to-sell/3" component={SecretaryCertificateToSellStep3} />
								<Route path="/contracts/free-contracts/secretary-certificate-to-sell/ty" component={Ty} />
								<Route component={DefaultView} />
							</Switch>

						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default SecretaryCertificateToSell;


// WEBPACK FOOTER //
// ./src/pages/contracts/free-contracts/secretary-certificate-to-sell/SecretaryCertificateToSell.js